import React from 'react';
import shallowCompare from '../../lib/shallowCompare';
import styles from './index.sass';

class MarketingAboutContainer extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  render() {
    let helmetProps = {
      meta: [
        {name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'},
      ]
    };

    return (
      <div className={styles.container}>
        <img className={styles.teamPhoto} src={'https://s3.amazonaws.com/delectory-uploads-production/Delectable.jpg'} alt="The Banquet Team" />
        <p className={styles.body}>
          Welcome to Banquet. Our journey started with Delectable, a mobile app that continues to bring together a passionate and diverse group of wine and spirit lovers. Now we’re bringing together America’s best merchants onto an ecommerce platform – a place that is fueled by the Delectable community. The excitement produced from this growing network is what drives us to create the best product for you and your customers.
          <br/>
          <br/>
          We’re a small team based in San Francisco. Our individual talents and shared interests combine to create something very special. From our very own winemaker to stories from far away lands like Norway and New Jersey, our fun and comedic crew is nothing short of extraordinary. We look forward to working with you.
        </p>
      </div>
    );
  }
}

export default MarketingAboutContainer;



// WEBPACK FOOTER //
// banquet/containers/MarketingAboutContainer/index.js